import { action } from '@ember/object';
import Component from '@glimmer/component';
import tippy from 'tippy.js';

export default class AtomsFormsDropdownComponent extends Component {
  tippyInstance;

  @action
  createTippy(element) {
    let tigger = element.querySelector('#dropdown-trigger');
    let dropdown = element.querySelector('.tippy-dropdown');
    this.tippyInstance = tippy(tigger, {
      content: dropdown,
      placement: this.args.placement ?? 'bottom-end',
      arrow: false,
      trigger: 'click',
      interactive: true,
      offset: [0, 4],
    });
  }

  @action
  handleSelect(e) {
    this.tippyInstance.hide();
    this.args.onSelect(e);
  }

  @action
  findValueFromOptions() {
    // (this.args.options.filter((item) => item.value === this.args.value)[0]);
    return (
      this.args.options.filter((item) => item.value === this.args.value)?.[0]
        ?.label ?? 'N/A'
    );
  }

  get lastOption() {
    return this.args.options[this.args.options.length - 1];
  }
}
